import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// Guarded like every other page: the back office is staff-only, the landing page included. Which
// three routes stay public, and why: apps/admin-panel/docs/tutto-il-backoffice-e-dello-staff.md.
export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/dashboard.tsx')),
})
